











import { Component, Emit, Prop, PropSync, Vue, Model, Watch } from 'vue-property-decorator';
//@ts-ignore
import { shiftDataStore } from '@/store/theoryApiStore/shiftDataModule.ts';

@Component
export default class DraggableEvent extends Vue {
  @Prop({type: String, required: true})
  public innerHtml!: string;

  @Prop({type: Object, required: true})
  public event!: any;

  @Prop({type: Function, required: true})
  public clickEvent!: (eventId: string, element: Element) => void

  @Prop({type: Boolean, required: false, default: false})
  public removeMarginRight!: boolean;

  private clicked() {
    this.clickEvent(this.event.eventId, this.$el)
  }

  get isTemporary() {
    return shiftDataStore.getSingleEvent(this.event.eventId)!.temporary;
  }

  get elevationClass() {
    return shiftDataStore.getSingleEvent(this.event.eventId)!.temporary ? 'elevation-6' : '';
  }

  get zIndexClass () {
    return shiftDataStore.getSingleEvent(this.event.eventId)!.temporary ? 'elevated' : '';
  }

  get marginClass() {
    return this.removeMarginRight ? 'remove-margin-v-event-draggable' : 'v-event-draggable'
  }

  @Watch('event')
  onChangeEvent(newValue: any, oldValue:any) {
    shiftDataStore.assignMonthlyCalendarDom({
      domElement: this.$el,
      eventId: newValue.eventId
    })
  }

  mounted() {
    this.$nextTick(function() {
      shiftDataStore.assignMonthlyCalendarDom({
        domElement: this.$el,
        eventId: this.event.eventId
      })
    })
  }
}
